import {$http} from '@/utils/https'
import {

    SET_USER_INFO, SET_USER_UPDATED_INFO

} from '../mutation-types';
import {
    GET_DATA, UPDATE_DATA

} from '../action-types';


const state = {
    userInfo: '',
    updatedData: ''
};
const actions = {

    [GET_DATA]: async ({commit},) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.get(`v1/user`);

            commit(SET_USER_INFO, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },
    [UPDATE_DATA]: async ({commit}, payload) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.post(`v1/user`, payload);

            commit(SET_USER_INFO, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },
}

const getters = {
    userInfo: state => state.userInfo,
    updatedData: state => state.updatedData
};

const mutations = {
    [SET_USER_INFO](state, data) {
        state.userInfo = data
    },
    [SET_USER_UPDATED_INFO](state, data) {
        state.updatedData = data
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
}
